import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import JournalThumbHtmlView from './JournalHtml';
import JournalThumbReactView from './Journal';
const JournalThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(JournalThumbHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(JournalThumbReactView, _extends({}, props));
};
JournalThumbView.displayName = 'JournalThumbView';
export default JournalThumbView;
